var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{domProps:{"textContent":_vm._s(_vm.value ? 'check_box' : 'check_box_outline_blank')}})
}
var staticRenderFns = []

export { render, staticRenderFns }